import CamcFundHero from "./camc-hero";

document.addEventListener("DOMContentLoaded", () => {
    if (window.fundCode) {
        const camcFundHero = new WebsiteCamcFundHero(window.fundCode);
        camcFundHero.render();
    }
});

class WebsiteCamcFundHero extends CamcFundHero {
    errorHandler() {
        showApiMessageing(null);
    }

    renderFundHero(fundHeroData) {
        if (fundHeroData.nav) {
            $("div.fund-nvl-group > div.fund-nvl").html(fundHeroData.nav);
            $("div.fund-nvl-group > div.fund-date-update").html(fundHeroData.priceDate);
        }

        let fund_date_performance = fundHeroData.changeInPer;
        if (fund_date_performance > 0) {
            $("div.fund-date-performance > span").addClass("text-primary-red");
            fund_date_performance = "+" + fund_date_performance;
        } else if (fund_date_performance < 0) {
            $("div.fund-date-performance > span").addClass("text-green");
        }

        $("div.fund-date-performance > span").html(fund_date_performance ? fund_date_performance + "%" : "-");
        $("div.heading-stacked-group > div.fund-assert-stacked-group > div.assert-class").html(fundHeroData.fundType);
        $("div.risk-level-stacked-group > div").html(fundHeroData.riskRating);

        if (fundHeroData.legalName && fundHeroData.legalName != "-") {
            let fundLegalName = fundHeroData.legalName;
            $("head title").html(fundLegalName);
        }

        if (fundHeroData.accumulatedPrice) {
            $("div.fund-invest-group > div.fund-invest-nvl").html(fundHeroData.accumulatedPrice);
            $("div.fund-invest-group > div.fund-invest-update").html(fundHeroData.accumulatedPriceDate);
        }
    }
}
